import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import PagePaiement from "./PagePaiement.js";
import { logDev } from "../utils/logger.js";

const PaiementRouter = ({ headerHeight = 0 }) => {
  const { groupeId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const upgradeSuccess = searchParams.get("upgrade");
  const duration = searchParams.get("duration");

  useEffect(() => {
    if (!groupeId) {
      logDev("❌ PaiementRouter monté sans groupeId");
      navigate("/connexion");
      return;
    }

    if (upgradeSuccess === "success") {
      logDev("✅ Paiement réussi, redirection vers /connexion", { groupeId, duration });
      sessionStorage.setItem("groupeId", groupeId);
      navigate(`/contacts?upgrade=success&duration=${duration || ""}`);
      return;
    }

    logDev("📡 PaiementRouter monté avec groupeId", { groupeId });
  }, [groupeId, upgradeSuccess, duration, navigate]);

  return <PagePaiement headerHeight={headerHeight} groupeId={groupeId} />;
};

export default PaiementRouter;
